import { Component, OnInit, OnDestroy } from '@angular/core';
// Enums
import { Vistas } from '../shared/enums/vistas';
// Models
import { Pagina, Seccion } from 'src/app/shared/models/pages';
import { NavbarSection } from '../shared/models/navbar-section.model';
// Services
import { PageService } from '../shared/services/page.service';
import { setPageTitle } from '../shared/utilities/utils';
import { AppService } from 'src/app/app.service';
import { MetatagsService } from '../shared/services/metatags.service';
import { CanonicalRoutesService } from '../shared/services/canonical-routes.service';

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent implements OnInit, OnDestroy {
  // Page data
  public pageData: Pagina;

  public options: NavbarSection[];

  private appEnvironment: string;

  constructor(
    private pagesService: PageService,
    private app: AppService,
    private metaTags: MetatagsService,
    private canonical: CanonicalRoutesService
  ) {
    this.appEnvironment = this.app.configuration['GraphCMS']['environment'];

    this.getPageData();
  }

  ngOnInit(): void {
    this.canonical.setCanonicalRoute();
  }

  ngOnDestroy(): void {
    this.metaTags.removeMetaTags(this.pageData.metaDescripciones);
  }

  private getPageData(): void {
    this.pagesService
    .getPage(
      Vistas.Business,
      'Empresas',
    )
    .subscribe((data: Pagina) => {
      this.setProducts(data);

      const titleElement = document.querySelector('title');
      setPageTitle(titleElement, this.pageData.vista);
      this.setOptions(data.secciones);

      this.metaTags.setMetaTags(data.metaDescripciones);
    });
  }

  private setProducts(data: Pagina) {
    this.pageData = data;
    this.pageData.secciones.forEach((seccion: Seccion) => {
      seccion.products = [];
      seccion.products = seccion.products.concat(seccion.pda);
      seccion.products = seccion.products.concat(seccion.ptu);
      seccion.products = seccion.products.concat(seccion.ptm);
    });
  }

  private setOptions(secciones: Seccion[]): void {
    if (secciones) {
      this.options = [];
      secciones.forEach(section => {
        this.options.push({
          id: section.idSeccion,
          title: section.tituloLinkSeccion,
          value: section.posicion,
        });
      });
    }
  }
}
